import React, { Component, Fragment } from "react";
import BaseComponent, { connect } from "@common/components/base.component";
import autoBind from "react-autobind";
import Fab from "@common/externos/components/fab/fab.externo";
import { Row, Col } from "react-bootstrap";
import Typography from "@material-ui/core/Typography";
import api from "../service/servicoEmpresa.service";

class Container extends BaseComponent {
  constructor(props) {
    super(props);
    autoBind(this);

    this.state = {
      modulos: []
    };
  }

  async componentDidMount() {
    const response = await api.getModulosAtivosByIdSistema();
    this.setState({ modulos: response.data });
  }

  redirect({ Alias, State: name }) {
    const { routerManager } = this.props;
    routerManager.redirect({ name });
  }

  render() {
    const { modulos } = this.state;

    if (!modulos.length)
      return (
        <div className="text-center text-muted p-5">
          <Typography>
            Não existem módulos habilitados para Serviços Empresa.
          </Typography>
        </div>
      );

    return (
      <Row>
        {modulos.map((modulo, index) => (
          <Col xs={12} lg={4} key={index}>
            <Fab
              title={modulo.Nome}
              icon={`fas fa-${modulo.Icone}`}
              onClick={() => this.redirect(modulo)}
            />
          </Col>
        ))}
      </Row>
    );
  }
}

export default connect()(Container);
